import {
  createQueryClientProvider,
  type CreateQueryClientProviderComponent,
} from '@internal/backstage-plugin-neo4j-ui-kit-react';

const STALE_TIME_MS = 60_000;

export const QueryClientProvider: CreateQueryClientProviderComponent =
  createQueryClientProvider(
    {
      defaultOptions: {
        queries: {
          staleTime: STALE_TIME_MS,
        },
      },
    },
    { displayName: 'Neo4jTechdocsQueryClientProvider' },
  );
